import { supabase } from '../../supabase';
import { pkTodayKey } from '../../utils/pkTime';

function isRpcMissing(error) {
  const msg = String(error?.message || error || '').toLowerCase();
  return (
    msg.includes('could not find the function')
    || msg.includes('function public.get_memberships_page')
    || msg.includes('schema cache')
    || (msg.includes('get_memberships_page') && msg.includes('does not exist'))
  );
}

function isoDate(value) {
  const d = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null;
}

function cleanFilters(filters = {}) {
  const out = {};
  [
    'serialNo',
    'gymId',
    'member',
    'name',
    'phone',
    'mobile',
    'email',
    'gender',
    'dob',
    'trainer',
    'cnic',
    'package',
    'duration',
    'start',
    'startDate',
    'expiry',
    'expiryDate',
    'status',
    'autoRenewal',
    'paymentNote',
    'date',
    'createdAt',
  ].forEach((key) => {
    const value = String(filters[key] ?? '').trim();
    if (value && value !== 'all' && value !== '—') out[key] = value;
  });
  return out;
}

export async function fetchMembershipsPageRpc({
  gymId,
  page = 1,
  pageSize = 50,
  search = '',
  branch = '',
  filters = {},
  allMatching = false,
} = {}) {
  if (!gymId) return null;

  const from = isoDate(filters.rangeStart || filters.dateFrom);
  const to = isoDate(filters.rangeEnd || filters.dateTo);
  const branchValue = String(branch || '').trim();
  const pBranch = !branchValue || branchValue === 'all' ? null : branchValue;

  const { data, error } = await supabase.rpc('get_memberships_page', {
    p_gym_id: gymId,
    p_date_from: from,
    p_date_to: to,
    p_branch: pBranch,
    p_page: allMatching ? 0 : Math.max(1, Number(page) || 1),
    p_page_size: allMatching ? 20000 : Math.min(100, Math.max(10, Number(pageSize) || 50)),
    p_search: String(search || '').trim(),
    p_filters: cleanFilters(filters),
    p_today: pkTodayKey(),
  });

  if (error) {
    if (isRpcMissing(error)) return null;
    throw error;
  }
  const payload = typeof data === 'string'
    ? (() => { try { return JSON.parse(data); } catch { return null; } })()
    : data;
  if (!payload || payload.error) return null;

  return {
    total: Number(payload.total) || 0,
    page: Number(payload.page) || 1,
    pageSize: Number(payload.page_size) || pageSize,
    rows: Array.isArray(payload.rows) ? payload.rows : [],
    fromRpc: true,
  };
}
